import Messages from "@/Component/Messages"

const MessagesPage = () => {
  return (
    <Messages />
  )
}

export default MessagesPage
